import { login } from '@features/auth/auth.slice';
import { useLoginMutation } from '@services/core/auth/auth.endpoints';
import { LoginRequest } from '@services/core/auth/auth.types';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';

export const useLoginPageVM = () => {
    const dispatch = useDispatch();
    const [loginCall, { isLoading, isSuccess, data, isError, error }] = useLoginMutation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const redirectTo = searchParams.get('redirect');

    const handleSubmit = async (values: LoginRequest) => {
        loginCall({ email: values.email, password: values.password });
    };

    useEffect(() => {
        if (isError && error) {
            console.log('error', error);
            return;
        }
        if (isSuccess && data) {
            dispatch(login({ ...data.data.user, jwt: data.data.jwt }));
            navigate(redirectTo ?? '/members-management');
            return;
        }
    }, [isSuccess, isError]);

    return {
        handleSubmit,
        isLoading
    };
};
